import { createAction } from '@reduxjs/toolkit'

export const setOnlines = createAction('onlines/setOnlines')
export const setAvailable = createAction('onlines/setAvailable')
export const setInRoute = createAction('onlines/setInRoute')